import { ESignType } from '@sd-portal/shared/util';
import { EMPTY_SIGNED_TYPE } from './esigntype.model';
export interface ESignResponse {
  success: boolean;
  pinValid: boolean;
  errorMessage: string;
  eSignableTypeDto: ESignType;
}

export const EMPTY_ESIGNRESPONSE: ESignResponse = {
  success: false,
  pinValid: false,
  errorMessage: '',
  eSignableTypeDto: EMPTY_SIGNED_TYPE
};

export interface ESignArchiveResponse {
  success: boolean;
  archives: ESignArchiveRecord[];
}

export interface ESignArchiveRecord {
  archiveSignId: number;
  signId: number;
  fileName: number;
  fileGuid: string;
  signDate: string;
  signedBy: string;
}
